import { sassmallRequest } from './client'

export interface SassmallArticle {
  id: string
  url?: string
  categoryId?: string
  topicId?: string
  contentType?: 'RICH_TEXT' | 'VIDEO' | 'EXTERNAL_LINK'
  title?: string
  summary?: string
  coverUrl?: string
  content?: string
  videoUrl?: string
  externalUrl?: string
  publishTime?: string
  readCount?: number
  i18nJson?: string | Record<string, unknown> | null
}

export interface SassmallHelpCategory {
  id: string
  parentId?: string
  level?: number
  name?: string
  iconUrl?: string
  sortNo?: number
  children?: SassmallHelpCategory[]
  i18nJson?: string | Record<string, unknown> | null
}

export function getSassmallArticleCategoryByUrl(url: string) {
  return sassmallRequest<SassmallHelpCategory>('/content/article-categories/by-url', { method: 'GET', query: { url } })
}

export interface SassmallHelpFaq {
  id: string
  categoryId?: string
  question?: string
  answer?: string
  sortNo?: number
  publishTime?: string
  i18nJson?: string | Record<string, unknown> | null
}

export function pageSassmallArticles(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/content/articles/page', {
    method: 'POST',
    body: {
      ...payload,
      pageNo: Number(payload.pageNo || 1),
      pageSize: Number(payload.pageSize || 20),
      keyword: String(payload.keyword || '').trim() || undefined,
    },
  })
}

export function getSassmallArticleDetail(id: string | number) {
  return sassmallRequest<SassmallArticle>(`/content/articles/${encodeURIComponent(String(id))}`, { method: 'GET' })
}

export function getSassmallArticleByUrl(url: string) {
  return sassmallRequest<SassmallArticle>('/content/articles/by-url', { method: 'GET', query: { url } })
}

export function readSassmallArticle(id: string | number) {
  return sassmallRequest<void>(`/content/articles/${encodeURIComponent(String(id))}/read`, { method: 'POST' })
}

export function getSassmallHelpCategoryTree(channel: 'APP' | 'H5' | 'WEB' = 'WEB') {
  return sassmallRequest<SassmallHelpCategory[]>('/help/categories/tree', {
    method: 'GET',
    query: { channel },
  })
}

export function pageSassmallHelpFaqs(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/help/faqs/page', {
    method: 'POST',
    body: {
      ...payload,
      pageNo: Number(payload.pageNo || 1),
      pageSize: Number(payload.pageSize || 20),
      keyword: String(payload.keyword || '').trim() || undefined,
      channel: payload.channel || 'WEB',
    },
  })
}

export function searchSassmallHelpFaqs(payload: Record<string, any>) {
  return sassmallRequest<Record<string, any>>('/help/faqs/search', {
    method: 'POST',
    body: {
      ...payload,
      pageNo: Number(payload.pageNo || 1),
      pageSize: Number(payload.pageSize || 20),
      keyword: String(payload.keyword || '').trim() || undefined,
      channel: payload.channel || 'WEB',
    },
  })
}

export function getSassmallHelpFaqDetail(id: string | number, channel: 'APP' | 'H5' | 'WEB' = 'WEB') {
  return sassmallRequest<SassmallHelpFaq>(`/help/faqs/${encodeURIComponent(String(id))}`, {
    method: 'GET',
    query: { channel },
  })
}
